import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import CommentImageThumbnailEditor from './CommentImageThumbnailEditor.jsx';

const CommentImageThumbnailsContainer = ({ images, onImageRemove, onImageClick }) => {
    if (!images || images.length === 0) return null;

    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: 96,
                left: 24,
                right: 24,
                display: 'flex',
                flexWrap: 'nowrap',
                overflowX: 'auto',
                overflowY: 'visible',
                gap: '10px',
                padding: '10px 0 5px',
                zIndex: 3,
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    bottom: 140,
                },
            }}
        >
            {images.map((image, index) => {
                const imageUrl = typeof image === 'string' ? image : image.previewUrl;
                const imageId = typeof image === 'string' ? index : image.id;
                const handleRemove = onImageRemove && typeof image !== 'string' ? () => onImageRemove(imageId) : undefined;
                const handleClick = onImageClick ? () => onImageClick(index) : undefined;

                return <CommentImageThumbnailEditor key={imageId} imageUrl={imageUrl} onRemove={handleRemove} onClick={handleClick} />;
            })}
        </Box>
    );
};

CommentImageThumbnailsContainer.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                previewUrl: PropTypes.string,
            }),
        ]),
    ),
    onImageRemove: PropTypes.func,
    onImageClick: PropTypes.func,
};

export default CommentImageThumbnailsContainer;
